'use client'
import { useState } from 'react'

// Single FAQ row: a real <button> toggles the answer, with a visible +/− marker.
// Styles live in app/globals.css (FAQ section).
function FaqItem({ item, index, expanded, onToggle, idPrefix }) {
    const itemId = `${idPrefix}-item-${index}`

    return (
        <>
            <dt>
                <button
                    type="button"
                    onClick={onToggle}
                    className={`faq-toggle-btn ${expanded ? 'active' : ''}`}
                    aria-expanded={expanded}
                    aria-controls={`${itemId}-answer`}
                    id={`${itemId}-question`}
                >
                    <span>{item.question}</span>
                    <span aria-hidden="true" className="faq-toggle-icon">
                        {expanded ? '−' : '+'}
                    </span>
                </button>
            </dt>
            <dd
                className={`faqAnswer faq-answer ${expanded ? 'is-open' : ''}`}
                id={`${itemId}-answer`}
                role="region"
                aria-labelledby={`${itemId}-question`}
                aria-hidden={!expanded}
            >
                <div className="faq-answer__clip">
                    <div className="faq-answer__body">
                        {item.answer}
                    </div>
                </div>
            </dd>
        </>
    )
}

export default function Faq({ items, idPrefix = 'faq' }) {
    const [currentIndex, setCurrentIndex] = useState(-1)

    return (
        <dl className="toggle faq-list">
            {items.map((item, index) => (
                <FaqItem
                    key={item.question}
                    item={item}
                    index={index}
                    idPrefix={idPrefix}
                    expanded={currentIndex === index}
                    onToggle={() =>
                        setCurrentIndex((prev) => (prev === index ? -1 : index))
                    }
                />
            ))}
        </dl>
    )
}
